import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';


import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { MatDialogModule } from '@angular/material/dialog';
import { CdkTableModule } from '@angular/cdk/table';
import { MatSortModule } from '@angular/material/sort';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';


import { AppComponent } from './app.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';

import {
  AgmCoreModule
} from '@agm/core';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './login/login.component';

import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { OtpPasswordComponent } from './otp-password/otp-password.component';
import { UserSignupComponent } from './user-signup/user-signup.component';
import { Search1ScreenComponent } from './search1-screen/search1-screen.component';
import { EmergencyComponent } from './emergency/emergency.component';
import { FoodComponent } from './food/food.component';
import { FoodServiceComponent } from './food/food-service/food-service.component';
import { AdditionalDetailsComponent } from './user-signup/additional-details/additional-details.component';
import { YChildrenComponent } from './user-signup/y-children/y-children.component';
import { StatusSignupComponent } from './user-signup/status-signup/status-signup.component';
import { PrintComponent } from './food/print/print.component';
import { UserHistoryComponent } from './user-history/user-history.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ReferralDownloadComponent } from './food/referral-download/referral-download.component';
import { More211servicesComponent } from './food/more211services/more211services.component';
import { HistoryDetailsComponent } from './user-history/history-details/history-details.component';
import { TaxAssistamceComponent } from './tax-assistamce/tax-assistamce.component';
import { SocialSecurityComponent } from './tax-assistamce/social-security/social-security.component';
import { TaxPrepComponent } from './tax-assistamce/tax-prep/tax-prep.component';
import { VirtualSelectionComponent } from './tax-assistamce/virtual-selection/virtual-selection.component';
import { VeteranCenterComponent } from './tax-assistamce/virtual-selection/veteran-center/veteran-center.component';
import { ScheduleAppointmentComponent } from './tax-assistamce/schedule-appointment/schedule-appointment.component';
import { HybridComponent } from './hybrid/hybrid.component';
import { Box7HybridComponent } from './hybrid/box7-hybrid/box7-hybrid.component';
import { TaxreturnExpertiseComponent } from './hybrid/taxreturn-expertise/taxreturn-expertise.component';
import { MaterialGoodsComponent } from './material-goods/material-goods.component';



@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    MatCardModule,
    MatDatepickerModule,
    BrowserModule,
    MatDialogModule,
    CdkTableModule,
    MatSortModule,
    MatNativeDateModule,
    MatRippleModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatRadioModule,
    MatCheckboxModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    MatTabsModule,
 

    AgmCoreModule.forRoot({
      apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    }),
  
  ],
  exports: [
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSidenavModule,
    MatToolbarModule,
    MatFormFieldModule ,
    MatInputModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LoginComponent,
    CustomerDetailsComponent,
    OtpPasswordComponent,
    UserSignupComponent,
    Search1ScreenComponent,
    EmergencyComponent,
    FoodComponent,
    FoodServiceComponent,
    AdditionalDetailsComponent,
    YChildrenComponent,
    StatusSignupComponent,
    PrintComponent,
    UserHistoryComponent,
    FeedbackComponent,
    ReferralDownloadComponent,
    More211servicesComponent,
    HistoryDetailsComponent,
    TaxAssistamceComponent,
    SocialSecurityComponent,
    TaxPrepComponent,
    VirtualSelectionComponent,
    VeteranCenterComponent,
    ScheduleAppointmentComponent,
    HybridComponent,
    Box7HybridComponent,
    TaxreturnExpertiseComponent,
    MaterialGoodsComponent,

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
